<script lang="ts">

</script>

<template>
  <div class="divide-y divide-slate-100 border-t border-slate-100">
    <slot />
  </div>
</template>
